import { z } from 'zod';
import { sex } from '@/schemas/API/common/atomic/sex';
import { date } from '@/schemas/API/common/atomic/date';
import { addressSchema } from '@/schemas/API/common/basic/address';
import { emergencyContactSchema } from '@/schemas/API/common/basic/emergencyContact';
import { accessSchema } from '@/schemas/API/common/basic/access';
import { phone } from '@/schemas/API/common/atomic/phone';
import { email } from '@/schemas/API/common/atomic/email';
import { employeeCardSchema } from '@/schemas/API/common/basic/employeeCard';
import { tagSchema } from '@/schemas/API/common/basic/tag';

const courseSchema = z.object({
  name: z.string().min(1),
  date,
  hours: z.number().min(1),
});

const languageSkillSchema = z.object({
  name: z.string().min(1, ' '),
  level: z.string().min(1, ' '),
});


export const empTypeSchema = z.union([z.literal('DPP'), z.literal('HPP')]);

export const empTimeSchema = z.union([
  z.literal('HALF'),
  z.literal('FULL'),
  z.literal('QUARTER'),
  z.literal('THREE_QUARTER'),
]).nullable();

export const createEmployeeSchema = z.object({
  firstName: z.string().min(1, {message: 'Jméno musí být dlouhé aspoň 2 znaky'}),
  lastName: z.string().min(1, {message: 'Příjmení musí být dlouhé aspoň 2 znaky'}),
  title: z.string().nullable(),
  sex,
  phone,
  email,
  birthdate: date,
  birthplace: z.string().min(1, 'Místo narození můsí být dlouhé aspoň 2 znaky'),
  eduType: z.string().min(1, 'Typ vzdělání musí být dlouhé aspoň 2 znaky'),
  numOfVacationDays: z.number(),
  empType: empTypeSchema,
  empTime: empTimeSchema,
  canFirstAid: z.boolean(),
  permAddress: addressSchema,
  courses: z.array(courseSchema),
  langs: z.array(languageSkillSchema),
  contacts: z.array(emergencyContactSchema),
  cards: z.array(employeeCardSchema),
  tags: z.array(z.number()),
  access: accessSchema,
});

export type CreateEmployee = z.infer<typeof createEmployeeSchema>;

export const defaultEmployee: CreateEmployee = {
  firstName: '',
  lastName: '',
  title: null,
  sex: 'O',
  phone: '',
  email: '',
  birthdate: '',
  birthplace: '',
  eduType: '',
  numOfVacationDays: 0,
  empType: 'HPP', // TODO: send empty and select the right value when creating a new employee
  empTime: 'FULL', // TODO: send empty and select the right value when creating a new employee
  canFirstAid: true,
  permAddress: {
    street: '',
    city: '',
    postCode: '',
    descNum: 0,
    orientNum: 0,
  },
  courses: [],
  langs: [],
  contacts: [
    {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      relation: '',
    },
  ],
  cards: [],
  tags: [],
  access: {
    services: [],
    role: '',
  },
};
